export const PRODUCT_REQUEST_VEG = "PRODUCT_REQUEST_VEG";
export const PRODUCT_REQUEST_NON_VEG = "PRODUCT_REQUEST_NON_VEG";
export const PRODUCT_REQUEST = "PRODUCT_REQUEST";
// export const PRODUCT_REQUEST_COLLECTION = "PRODUCT_REQUEST_COLLECTION"
// export const PRODUCT_REQUEST_WISHLIST = "PRODUCT_REQUEST_WISHLIST"
export const SINGLE_PRODUCT_REQUEST = "SINGLE_PRODUCT_REQUEST";
export const PRODUCT_REQUEST_BRACELETS = "PRODUCT_REQUEST_BRACELETS";
export const IsLoading = "isLoading";
export const IsError = "isError";
export const TOTALPAGE = "TOTALPAGE";
export const COMMENT_ADD="COMMENT_ADD"
export const LIKE_ADD="LIKE_ADD"
export const LIKE_REMOVE="LIKE_REMOVE"
